import { AiToolImpl } from "@me8eon/aiclient";
import { addDeviceToEntraGroup } from "./model/graphApi";
import { JwtTokenFn } from "@me8eon/authentication";

type ToolArgs = {
    deviceName: string;
}

type ToolImpl = AiToolImpl<ToolArgs>

type Tool = (jwtTokenFn: JwtTokenFn) => ToolImpl

const GROUP_NAME = "DMP_APL211023_MWP-D-EDGE-Startup";

export const AddDeviceToEntraGroupToolImpl: Tool = (jwtTokenFn) => {
    return {
        type: "graph",
        toolDefn: {
            type: 'function',
            name: "add_device_to_entra_group",
            description: `Adds the provided device to Entra group '${GROUP_NAME}'. Call this only after user confirmation.`,
            parameters: {
                type: "object",
                required: ["deviceName"],
                additionalProperties: false,
                properties: {
                    deviceName: {
                        type: "string",
                        description: "Device name to add to the Entra group.",
                    },
                }
            },
        },
        execute: async (indices, { deviceName }) => {
            const result = await addDeviceToEntraGroup(deviceName, GROUP_NAME, jwtTokenFn);

            if (result.success) {
                return {
                    value: `✅  Microsoft Graph API call confirmed.`,
                    _meta: {
                        success: true,
                        deviceName,
                        groupId: GROUP_NAME,
                    }
                };
            } else {
                return {
                    value: `❌ ${result.error}`,
                    _meta: {
                        success: false,
                        error: result.error,
                    }
                };
            }
        }
    }
}